import { Link } from "react-router-dom";
import Text from "../../components/Text";

const InPersonServiceTab = () => {
  return (
    <>
      <div className="heading text-[#5f5f5f] pb-5">
        <Text classes="uppercase font-bold font-medium" component={"h6"}>
          Categories
        </Text>
      </div>
      <div className="service-details flex">
        <div className="categories-navigator xs:hidden md:block w-3/12">
          <div className="wrapper bg-[#f8f8f8] mt-4 mr-8 p-6 inline-block text-sm text-black font-medium">
            <ul className="nav-items">
              <li className="single-nav-item border-b last:border-b-0">
                <Link
                  to={"#"}
                  className="py-5 inline-block transition-all duration-300 hover:text-[#e46552] focus:text-[#e46552]"
                >
                  Personalized nutrition (3)
                </Link>
              </li>
              <li className="single-nav-item border-b last:border-b-0">
                <Link
                  to={"#"}
                  className="py-5 inline-block transition-all duration-300 hover:text-[#e46552] focus:text-[#e46552]"
                >
                  Body Therapy (2)
                </Link>
              </li>
              <li className="single-nav-item border-b last:border-b-0">
                <Link
                  to={"#"}
                  className="py-5 inline-block transition-all duration-300 hover:text-[#e46552] focus:text-[#e46552]"
                >
                  Healthy Food (3)
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="categories xs:w-full md:w-9/12">
          <ul className="categories-wrapper text-[13px]">
            <li className="single-category border-b-[1px] last:border-b-0">
              <div className="single-category-wrapper py-6 flex lg:justify-between items-center flex-wrap">
                <div className="cat-desc text-[#8b8b8b] xs:my-3 md:my-0 xs:w-10/12 lg:w-6/12">
                  <Text
                    classes="font-medium text-black text-base"
                    component={"h4"}
                  >
                    Initial Assessment
                  </Text>
                  <Text classes={"text-[#8b8b8b]"}>
                    15 minutes initial consultation, Initial dietary analysis
                  </Text>
                </div>
                <div className="time xs:w-3/12 sm:w-2/12 flex xs:flex-col md:flex-row xs:justify-end xs:my-3 md:my-0">
                  <Text classes={"text-[#e66553] text-sm"}>15 min</Text>
                </div>
                <div className="price-and-action flex items-center justify-end xs:w-full lg:w-4/12 xs:my-3 md:my-0">
                  <div className="price mr-6">
                    <Text
                      classes={"text-[#e66553] text-sm font-medium"}
                      component={"strong"}
                    >
                      Free
                    </Text>
                  </div>
                  <div className="action">
                    <Link
                      to="scheduling"
                      className="uppercase shrink-0 inline-flex items-center bg-[#D66D5A] text-white rounded text-center h-10 px-6 transition-all duration-200 hover:text-[#D66D5A] hover:bg-white border-2 border-[#D66D5A] hover:-translate-y-[2px] text-sm"
                    >
                      Start Now
                    </Link>
                  </div>
                </div>
              </div>
            </li>
            <li className="single-category border-b-[1px] last:border-b-0">
              <div className="single-category-wrapper py-6 flex justify-between items-center flex-wrap ">
                <div className="cat-desc text-[#8b8b8b] xs:my-3 md:my-0 xs:w-9/12 sm:w-10/12 lg:w-6/12">
                  <Text
                    classes="font-medium text-black text-base"
                    component={"h4"}
                  >
                    Initial Assessment
                  </Text>
                  <Text>Weekly follow-ups</Text>
                  <Text>App Support</Text>
                  <Text>Progress Tracker</Text>
                  <Text>Customized Snack Box</Text>
                </div>
                <div className="time xs:w-3/12 sm:w-2/12 flex xs:flex-col md:flex-row xs:justify-end xs:my-3 md:my-0">
                  <Text classes={"text-[#e66553] text-sm mr-1"}>30</Text>
                  <Text classes={"text-[#e66553] text-sm mr-1"}>
                    min/weekly
                  </Text>
                </div>
                <div className="price-and-action flex items-center justify-end xs:w-full lg:w-4/12 xs:my-3 md:my-0">
                  <div className="price mr-6 flex flex-col items-end">
                    <Text classes={"text-[#e66553] text-sm font-medium"}>
                      $99
                    </Text>
                    <Text classes={"text-[#747474] text-[11px] font-medium"}>
                      Monthly
                    </Text>
                  </div>
                  <div className="action">
                    <Link
                      to="scheduling"
                      className="uppercase shrink-0 inline-flex items-center bg-[#D66D5A] text-white rounded text-center h-10 px-6 transition-all duration-200 hover:text-[#D66D5A] hover:bg-white border-2 border-[#D66D5A] hover:-translate-y-[2px] text-sm"
                    >
                      Start Now
                    </Link>
                  </div>
                </div>
              </div>
            </li>
            <li className="single-category border-b-[1px] last:border-b-0">
              <div className="single-category-wrapper py-6 flex justify-between items-center flex-wrap">
                <div className="cat-desc text-[#8b8b8b] xs:my-3 md:my-0 xs:w-9/12 sm:w-10/12 lg:w-6/12">
                  <Text
                    classes="font-medium text-black text-base"
                    component={"h4"}
                  >
                    Transform Me
                  </Text>
                  <Text>Weekly follow-ups</Text>
                  <Text>App Support</Text>
                  <Text>Progress Tracker</Text>
                  <Text>Customized Snack Box</Text>
                </div>
                <div className="time xs:w-3/12 sm:w-2/12 flex xs:flex-col md:flex-row xs:justify-end xs:my-3 md:my-0">
                  <Text classes={"text-[#e66553] text-sm mr-1"}>30</Text>
                  <Text classes={"text-[#e66553] text-sm mr-1"}>
                    min/weekly
                  </Text>
                </div>
                <div className="price-and-action flex items-center justify-end xs:w-full md:w-4/12 xs:my-3 md:my-0">
                  <div className="price mr-6 flex flex-col items-end">
                    <Text classes={"text-[#e66553] text-sm font-medium"}>
                      $99
                    </Text>
                    <Text classes={"text-[#747474] text-[11px] font-medium"}>
                      Monthly
                    </Text>
                  </div>
                  <div className="action">
                    <Link
                      to="scheduling"
                      className="uppercase shrink-0 inline-flex items-center bg-[#D66D5A] text-white rounded text-center h-10 px-6 transition-all duration-200 hover:text-[#D66D5A] hover:bg-white border-2 border-[#D66D5A] hover:-translate-y-[2px] text-sm"
                    >
                      Start Now
                    </Link>
                  </div>
                </div>
              </div>
            </li>
            <li className="single-category border-b-[1px] last:border-b-0">
              <div className="single-category-wrapper py-6 flex justify-between items-center flex-wrap">
                <div className="cat-desc text-[#8b8b8b] xs:my-3 md:my-0 xs:w-9/12 sm:w-10/12 lg:w-6/12">
                  <Text
                    classes="font-medium text-black text-base"
                    component={"h4"}
                  >
                    Transform Me
                  </Text>
                  <Text>Weekly follow-ups</Text>
                  <Text>App Support</Text>
                  <Text>Progress Tracker</Text>
                  <Text>Customized Snack Box</Text>
                </div>
                <div className="time xs:w-3/12 sm:w-2/12 flex xs:flex-col md:flex-row xs:justify-end xs:my-3 md:my-0">
                  <Text classes={"text-[#e66553] text-sm mr-1"}>30</Text>
                  <Text classes={"text-[#e66553] text-sm mr-1"}>
                    min/weekly
                  </Text>
                </div>
                <div className="price-and-action flex items-center justify-end xs:w-full lg:w-4/12 xs:my-3 md:my-0">
                  <div className="price mr-6 flex flex-col items-end">
                    <Text classes={"text-[#e66553] text-sm font-medium"}>
                      $99
                    </Text>
                    <Text classes={"text-[#747474] text-[11px] font-medium"}>
                      Monthly
                    </Text>
                  </div>
                  <div className="action">
                    <Link
                      to="scheduling"
                      className="uppercase shrink-0 inline-flex items-center bg-[#D66D5A] text-white rounded text-center h-10 px-6 transition-all duration-200 hover:text-[#D66D5A] hover:bg-white border-2 border-[#D66D5A] hover:-translate-y-[2px] text-sm"
                    >
                      Start Now
                    </Link>
                  </div>
                </div>
              </div>
            </li>
            <li className="single-category border-b-[1px] last:border-b-0">
              <div className="single-category-wrapper py-6 flex justify-between items-center flex-wrap">
                <div className="cat-desc text-[#8b8b8b] xs:my-3 md:my-0 xs:w-9/12 sm:w-10/12 lg:w-6/12">
                  <Text
                    classes="font-medium text-black text-base"
                    component={"h4"}
                  >
                    Transform Me
                  </Text>
                  <Text>Weekly follow-ups</Text>
                  <Text>App Support</Text>
                  <Text>Progress Tracker</Text>
                  <Text>Customized Snack Box</Text>
                </div>
                <div className="time xs:w-3/12 sm:w-2/12 flex xs:flex-col md:flex-row xs:justify-end xs:my-3 md:my-0">
                  <Text classes={"text-[#e66553] text-sm mr-1"}>30</Text>
                  <Text classes={"text-[#e66553] text-sm mr-1"}>
                    min/weekly
                  </Text>
                </div>
                <div className="price-and-action flex items-center justify-end xs:w-full lg:w-4/12 xs:my-3 md:my-0">
                  <div className="price mr-6 flex flex-col items-end">
                    <Text classes={"text-[#e66553] text-sm font-medium"}>
                      $99
                    </Text>
                    <Text classes={"text-[#747474] text-[11px] font-medium"}>
                      Monthly
                    </Text>
                  </div>
                  <div className="action">
                    <Link
                      to="scheduling"
                      className="uppercase shrink-0 inline-flex items-center bg-[#D66D5A] text-white rounded text-center h-10 px-6 transition-all duration-200 hover:text-[#D66D5A] hover:bg-white border-2 border-[#D66D5A] hover:-translate-y-[2px] text-sm"
                    >
                      Start Now
                    </Link>
                  </div>
                </div>
              </div>
            </li>
            <li className="single-category border-b-[1px] last:border-b-0">
              <div className="single-category-wrapper py-6 flex justify-between items-center flex-wrap">
                <div className="cat-desc text-[#8b8b8b] xs:my-3 md:my-0 xs:w-9/12 sm:w-10/12 lg:w-6/12">
                  <Text
                    classes="font-medium text-black text-base"
                    component={"h4"}
                  >
                    Transform Me
                  </Text>
                  <Text>Weekly follow-ups</Text>
                  <Text>App Support</Text>
                  <Text>Progress Tracker</Text>
                  <Text>Customized Snack Box</Text>
                </div>
                <div className="time xs:w-3/12 sm:w-2/12 flex xs:flex-col md:flex-row xs:justify-end xs:my-3 md:my-0">
                  <Text classes={"text-[#e66553] text-sm mr-1"}>30</Text>
                  <Text classes={"text-[#e66553] text-sm mr-1"}>
                    min/weekly
                  </Text>
                </div>
                <div className="price-and-action flex items-center justify-end xs:w-full lg:w-4/12 xs:my-3 md:my-0">
                  <div className="price mr-6 flex flex-col items-end">
                    <Text classes={"text-[#e66553] text-sm font-medium"}>
                      $99
                    </Text>
                    <Text classes={"text-[#747474] text-[11px] font-medium"}>
                      Monthly
                    </Text>
                  </div>
                  <div className="action">
                    <Link
                      to="scheduling"
                      className="uppercase shrink-0 inline-flex items-center bg-[#D66D5A] text-white rounded text-center h-10 px-6 transition-all duration-200 hover:text-[#D66D5A] hover:bg-white border-2 border-[#D66D5A] hover:-translate-y-[2px] text-sm"
                    >
                      Start Now
                    </Link>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default InPersonServiceTab;
